import {
  LEGEND_MAX_SCALE,
  LEGEND_MIN_SCALE,
  LEGEND_PAGE_MARGIN,
  LEGEND_REFERENCE_PAGE_SIDE,
  computeLegendDimensions,
} from "../LegendBox";
import type { ComputeLegendScale } from "./types";

export const computeLegendScale: ComputeLegendScale = ({
  pdfPageWidth,
  pdfPageHeight,
  itemCount,
}) => {
  const longerPageSide = Math.max(pdfPageWidth, pdfPageHeight);
  const proportionalScale = Math.min(
    LEGEND_MAX_SCALE,
    Math.max(LEGEND_MIN_SCALE, longerPageSide / LEGEND_REFERENCE_PAGE_SIDE),
  );

  // Cap the scale so the legend always fits within the page bounds (with its
  // own margin on each side). Width, height, and margin all scale linearly,
  // so each axis gives a single upper bound for the scale.
  const baseDimensions = computeLegendDimensions({ itemCount, scale: 1 });
  const widthFitScale =
    pdfPageWidth / (baseDimensions.width + 2 * LEGEND_PAGE_MARGIN);
  const heightFitScale =
    pdfPageHeight / (baseDimensions.height + 2 * LEGEND_PAGE_MARGIN);

  return Math.min(proportionalScale, widthFitScale, heightFitScale);
};
